import { render, staticRenderFns } from "./Verifactus.vue?vue&type=template&id=0efb6088&scoped=true"
import script from "./Verifactus.vue?vue&type=script&lang=js"
export * from "./Verifactus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb6088",
  null
  
)

export default component.exports